/** The list with the item at `from` placed at `to`, the others closing the gap; unchanged for an index off the list. */
export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) {
    return [...items]
  }
  const moved = items[from] as T
  const without = items.filter((_, index) => index !== from)
  return [...without.slice(0, to), moved, ...without.slice(to)]
}
